module.exports = __webpack_public_path__ + "img/cshomework3.0d7163b3.png";